<!-- 微博计划。2023.5.19微博看板上线，这个不用了 -->
<template>
<div>
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">微博计划</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 15px;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width + 'px'}">
			
			<div class="screen-box" style="margin-bottom:0;">
				<div class="screen-label">微博计划Id</div>
				<a-input v-model="r_adid" allowClear placeholder="请输入" style="width: 240px;"/>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			
			<!-- <a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">新增渠道</a-button> -->
		</div>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
		<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
			<div class="table-th-cell" style="cursor: default;" 
			:style="{'width':rableTitle[0].width + 'px'}" >
				{{rableTitle[0].title}}
				
			</div>
			<div class="table-th-cell" style="cursor: default;"
			:style="{'width':rableTitle[1].width + 'px'}" >
				{{rableTitle[1].title}}
			</div>
			
		</div>
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
		
			<div v-if="index > 1" class="table-th-cell" 
			:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
			>
				{{item.title}}
				<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
					<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
					<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
				</div>
			</div>
		</div>
		<!-- 占位，隔出一个空白区域 -->
		<div id="" style="padding:15px;"></div>
	</div>
	
	
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
			
				<div  class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					{{item.adid}}
				</div>
			
		</div>
		
		<!-- 回传比例 -->
		<div @click="setPlanHc(item)" class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}" style="cursor: pointer;color: rgb(98, 168, 234);">
			<div v-if="item.config" style="display: flex;align-items: center;">
				<div v-if="item.config.status == 1" style="margin-right: 7px;">已启用</div>
				<div v-else>未启用</div>
				<div>
					比例：{{item.config.report_per}}
				</div>
			</div>
			<div v-else>
				未设置
			</div>
			
		</div>
		
	</div>
	
	
	<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_scroll_width + 'px',}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	
	<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	

	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_scroll_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div>
	</div>
	
	
	<!-- 回传比例相关侧边栏 -->
	<a-drawer
	  title="计划回传比例"
	  width="650px"
	  placement="right"
	  :closable="false"
	  :visible="hc_visible"
	  @close="hcCloseDrawer"
	>
		<!-- <div v-if="h_type_pl == 0" class="form-cell-box">
			<div class="class-title">Id</div>
				
			<div style="font-size: 15px;">{{h_plan_name}}</div>
		</div> -->
		
		<div v-if="h_type_pl == 0" class="form-cell-box">
			<div class="class-title">微博计划ID</div>
				
			<div style="font-size: 15px;">{{h_plan_id}}</div>
		</div>
		
		<div v-if="h_type_pl == 1" class="form-cell-box" style="align-items: self-start;">
			<div class="class-title">已选的单元名称</div>
				
			<div>
				<div style="max-height: 240px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
					<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 11px;display: flex;align-items: center;margin-right: 10px;" class="">
						<!-- <div style="width: 70px;text-align: right;">{{item.plan_id}}</div>
						<span style="margin: 0 5px;"> — </span> -->
						<div style="width: 200px;">{{item.adgroupFeedName}}</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">回传最低金额(元)</div>
				
			<a-input-number @change='hcNumber($event,1)' :min="0" :max="100000" :value="h_report_money_limit" style="width: 130px;" />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">注册时间</div>
			
			<div>
				<a-radio-group @change="hcRadioA" name="radioGroup" :value="h_user_reg_time_condition">
					<a-radio :value="1">
					  只传注册当天用户
					</a-radio>
					<a-radio :value="0">
					  注册时间不限
					</a-radio>
				  </a-radio-group>
			</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">充值时间</div>
				
			<div>
				<a-radio-group @change="hcRadioB" name="radioGroup" :value="h_order_time_condition_type" style="width: 100%;">
					<a-radio :value="1">
						注册日期当天首次充值
					</a-radio>
					<a-radio :value="0" style="width: 260px;">
						<div style="display: inline-block;align-items: center;">
							注册后
							<a-input-number @change='hcNumber($event,2)' :min="0" :max="100000" :value="h_order_time_condition_n" style="width: 80px;margin: 0 5px;" />
							小时内首次充值
						</div>
					  
					</a-radio>
					
				  </a-radio-group>
			</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">回传比例</div>
				
			<a-input-number @change='hcNumber($event,3)' :min="0" :max="100000" :value="h_report_per"  style="width: 130px;" />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">是否启用</div> 
				
			<a-switch @change="hcDrawerSwitch" :checked="h_status" checked-children="启用" un-checked-children="暂停" />
		</div>
		
		<div style="color: red;height: 23px;margin-top: 35px;margin-bottom: -10px;margin-left: 40px;">{{hc_form_hint}}</div>
		
		<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
			<a-button @click="hcRequest" :loading="hc_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
			<a-button @click="hcCloseDrawer">取消</a-button>
		</div>
	
	</a-drawer>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
	
import { weiboPlanList, dzLinkAdd, weiboPlanReportConfig  } from '@/request/api'
export default {
	name: 'weiboPlan_',
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			table_scroll_width: 1600,
			
			r_limit: 50,
			r_page: 1,
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:150, sort_status:0, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"微博计划Id",width:230, sort_status:0, type:"link_id",},
				{title:"回传设置",width:230, sort_status:0, type:"name", },
				
			],
			tableShowData: [],
			
			search_button_loading: false, // 搜索按钮的加载状态
			
			
			visible: false,
			
			table_total: 0, // 表格内容总数
			
			body_width: 1800, // body的宽度
			
			
			r_adid: "", // 微博计划Id
			
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			
			// 回传比例侧边栏
			hc_plan_id: "", // 回传id
			hc_drawer_title: "", // 标题
			hc_visible: false, // 侧边栏是否显示
			hc_button_loading: false, // 回传侧边栏确认按钮的加载状态
			hc_form_hint: "",
			
			h_plan_name: "", // 单元名称，仅用于展示，不用于请求
			h_plan_id: "", // 单元ID
			h_report_money_limit: window.$InitialValues.report_money_limit, // 回传最低金额
			h_user_reg_time_condition: 1, // 注册时间
			h_order_time_condition_type: 1, // 充值时间
			h_order_time_condition_n: 24, // 注册后几小时内首次充值
			h_report_per: 100, // 回传比例
			h_status: true, // 是否启用-回传侧边栏
			
			h_type_pl: 0, // 0表示单个设置，1表示批量设置
		}
	},
	mounted(){
		let that = this
		that.body_width = document.body.clientWidth - 60
		console.log("that.body_width",that.body_width);
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		
		
		
		that.searchButton()
		
	},
	methods:{
		// 单个日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			
			this.endTime = dateString
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			
			weiboPlanList({
				limit: that.r_limit,
				page: that.r_page,
				adid: that.r_adid,
			}).then(res=>{
				console.log("搜索结果",res)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
					
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},100)
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		
		
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.searchButton()
		},
		
		
		// 计划回传比例侧边栏开始
		setPlanHc(e){
			console.log("jh",e);
			// this.h_plan_name = e.adid
			this.h_plan_id = e.adid // 微博计划Id
			let ee = e.config
			if(e.config){
				this.h_report_money_limit = ee.report_money_limit, // 回传最低金额
				this.h_user_reg_time_condition = ee.user_reg_time_condition, // 注册时间
				this.h_order_time_condition_type = ee.order_time_condition_type, // 充值时间
				this.h_order_time_condition_n = ee.order_time_condition_n, // 注册后几小时内首次充值
				this.h_report_per = ee.report_per // 回传比例
				
				if(ee.status == 1){ // 启用
					this.h_status = true // 是否启用-回传侧边栏
				}
				else {
					this.h_status = false
				}
				
			}
			this.h_type_pl = 0
			this.hc_visible = true
		},
		// 回传比例确认按钮
		hcRequest(){
			let that = this
			
			that.hc_button_loading = true
			
			let r_data = {
				report_money_limit: that.h_report_money_limit.toString(), // 回传最低金额
				user_reg_time_condition: that.h_user_reg_time_condition.toString(), // 注册时间
				order_time_condition_type: that.h_order_time_condition_type.toString(), // 充值时间
				report_per: that.h_report_per.toString() // 回传比例
			}
			if(that.h_status){// 是否启用
				r_data.status = '1' // 启用
			}
			else {
				r_data.status = '0'
			}
			// 选了注册后充值
			if(that.h_order_time_condition_type == 0){ 
				r_data.order_time_condition_n = that.h_order_time_condition_n // 注册后几小时内首次充值
			}
			
			// 是否批量
			if(that.h_type_pl == 1){ // 批量
				// let pl_plan_ids = []
				// that.selectedData.forEach(res=>{
				// 	pl_plan_ids.push(res.adgroupFeedId)
				// })
				// console.log("pl_plan_ids",pl_plan_ids);
				// // 设置请求参数
				// r_data.bd_unit_ids = pl_plan_ids
				
				// weiboPlanReportConfig(r_data).then(res=>{
				// 	that.hc_button_loading = false
				// 	console.log('批量设置回传',res)
				// 	if(res.data.code == 0){
						
				// 		that.selectedData = []
				// 		that.tableShowData.forEach(res=>{
				// 			res.checked = false // 重置
				// 		})
						
				// 		that.hcCloseDrawer()
				// 		that.$message.success('设置成功');
				// 		that.searchButton()
				// 	}
				// 	else {
				// 		that.$message.error(`其他错误：${res.data.msg}`);
				// 	}
				// })
			}
			else { // 单个设置
				r_data.adid = that.h_plan_id, // 微博计划Id
				
				weiboPlanReportConfig(r_data).then(res=>{
					that.hc_button_loading = false
					console.log('确认设置回传',res)
					if(res.data.code == 0){
						
						// that.selectedData = []
						// that.tableShowData.forEach(res=>{
						// 	res.checked = false // 重置
						// })
						
						that.hcCloseDrawer()
						that.$message.success('设置成功');
						that.searchButton()
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
					
				})
				.catch(err=>{
					that.hc_button_loading = false
					that.hcCloseDrawer()
					that.$message.error('设置失败，请检查网络状态')
				})
			}
			
			
		},
		// 回传比例侧边栏关闭
		hcCloseDrawer(){
			if(this.hc_button_loading){
				return
			}
			console.log('111111');
			this.hc_visible = false
			this.hc_form_hint = ""
			// 充值状态
			this.h_report_money_limit = window.$InitialValues.report_money_limit, // 回传最低金额
			this.h_user_reg_time_condition = 1, // 注册时间
			this.h_order_time_condition_type = 1, // 充值时间
			this.h_order_time_condition_n = 24, // 注册后几小时内首次充值
			this.h_report_per =  100// 回传比例
			this.h_status = true
			this.h_plan_name = ""
			this.h_plan_id = ""
			this.h_type_pl = 0
			
			
			document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			setTimeout(()=>{
				document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			},300)
		},
		// 回传比例侧边栏的是否启用按钮
		hcDrawerSwitch(e){
			console.log(e);
			this.h_status = e
		},
		hcRadioA(e){ // 注册时间
			console.log(e.target.value);
			this.h_user_reg_time_condition = e.target.value
		},
		hcRadioB(e){ // 充值时间
			console.log(e.target.value);
			this.h_order_time_condition_type = e.target.value
		},
		// 回传比例的数字输入框
		hcNumber(e,type){
			console.log(e,type);
			if(type == 1){ // 回传最低金额(元)
				this.h_report_money_limit = e
			}
			else if(type == 2){ // 注册后几小时内首次充值
				this.h_order_time_condition_n = e
			}
			else if(type == 3){ // 回传比例
				this.h_report_per = e
			}
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		
	}
}
</script>

<style scoped>

</style>